import { useDataContext } from '../context/data';
import translations from '../constants/translations.json';

const textShadow = { textShadow: '1px 1px 0px #000000' };

export default function GogiLanding({ onOrderViaMobile, onOrderViaBrowser }) {
  const { language } = useDataContext();

  const translation = translations[language] || translations['en'] || {};

  return (
    <div
      className="relative min-h-screen bg-black bg-cover bg-center bg-no-repeat flex items-start justify-center"
      style={{ backgroundImage: "url('/gogi-bg.png')" }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/[0.51] pointer-events-none" />

      {/* Content column */}
      <div className="relative z-10 flex flex-col items-center text-center w-full max-w-[1128px] gap-[10px] pb-[100px]">
        {/* Logo */}
        <div className="my-[50px]">
          <img
            src="/gogi-logo.png"
            alt="Gogi – The Korean Grill House"
            className="w-[200px] md:w-[250px] h-auto block"
          />
        </div>

        {/* Main heading */}
        <h4
          className="text-[24px] md:text-[30px] font-black leading-[1.2] text-white uppercase pb-8"
          style={textShadow}
        >
          {translation.gogi_welcome || 'Velkommen til Gogi'}
        </h4>

        {/* Order via app */}
        <div className="space-y-10">
          <div className="space-y-4">
            <h4
              className="text-[16px] md:text-[20px] font-black leading-none text-white uppercase"
              style={textShadow}
            >
              {translation.gogi_order_via_app || 'Order via app'}
            </h4>
            <button
              onClick={onOrderViaMobile}
              className="bg-[#ea1c2c] hover:bg-[#c8111f] active:translate-y-px text-white text-[13px] md:text-[15px] font-bold uppercase border-none cursor-pointer px-[32px] md:px-[40px] py-[13px] md:py-[15px] rounded-[75px] transition-colors duration-200"
            >
              {translation.gogi_order_here || 'Bestil her'}
            </button>
          </div>

          {/* Order via browser */}
          <div className="space-y-4">
            <h4
              className="text-[16px] md:text-[20px] font-black leading-none text-white uppercase"
              style={textShadow}
            >
              {translation.gogi_order_via_browser || 'Order via browser'}
            </h4>
            <button
              onClick={onOrderViaBrowser}
              className="bg-[#ea1c2c] hover:bg-[#c8111f] active:translate-y-px text-white text-[13px] md:text-[15px] font-bold uppercase border-none cursor-pointer px-[32px] md:px-[40px] py-[13px] md:py-[15px] rounded-[75px] transition-colors duration-200"
            >
              {translation.gogi_order_here || 'Bestil her'}
            </button>
          </div>
        </div>

        {/* Heywaitr branding */}
        <div className="pt-16">
          <img src="/heywaitr-logo.png" alt="heywaitr" className="w-[150px] h-auto block" />
        </div>
      </div>
    </div>
  );
}
